import { useLocation, useNavigate } from "react-router-dom";
import { scrollToSection } from "@/lib/api";

export const useHomeNavigation = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  return (hash) => {
    if (pathname === "/") scrollToSection(hash);
    else navigate(`/${hash}`);
  };
};